var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"font-poppins color-dark-blue",attrs:{"for":_vm.id}},[_vm._v("\n    "+_vm._s(_vm.label)+_vm._s(_vm.isRequired ? '*': '')+_vm._s(_vm.showLabelColon ? ':' : '')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }